// ** Third Party Components
import styled from "styled-components";

export const ControlButtonContainer = styled("div")`
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.3);
	border-radius: ${({ theme: { borderRadius } }) => borderRadius.card};
	height: 35px;
	padding: 0 0.6rem;
`;
